import useSmartAccount from './useSmartAccount'

const useProtocolKit = () => {
  const { smartAccount, ...rest } = useSmartAccount()
  smartAccount?.protocolKit.getPredictedSafe()
  return {
    protocolKit: smartAccount?.protocolKit,
    ...rest,
  }
}

export default useProtocolKit
